import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, ShieldCheck } from "lucide-react";
import { siteInfo } from "../mock";

const CTABanner = () => {
  return (
    <section className="relative py-24 md:py-28 bg-neutral-900 text-white overflow-hidden" data-testid="cta-banner-section">
      {/* Subtle dot texture */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" aria-hidden="true" style={{
        backgroundImage: "radial-gradient(#fff 1px, transparent 1px)",
        backgroundSize: "28px 28px"
      }} />
      {/* Amber halo */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute top-0 right-0 w-[560px] h-[560px] bg-amber-500/10 blur-3xl -translate-y-1/3 translate-x-1/4 rounded-full"></div>
      </div>

      <div className="max-w-[1280px] mx-auto px-5 md:px-10 relative">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/30 text-amber-200 px-3 py-1 text-[11px] font-semibold tracking-widest uppercase mb-5">
              <ShieldCheck size={13}/> Aanbevolen
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-5 leading-tight">
              Liever geen onverwachte
              <br/>
              <span className="italic font-light text-neutral-300">computerproblemen?</span>
            </h2>
            <p className="text-neutral-300 leading-relaxed text-lg">
              Vanaf <strong className="text-white">€15 per maand</strong> (of <strong className="text-white">€150 per jaar</strong>) bent u volledig ontzorgd — Bitdefender, onderhoud en onbeperkte hulp op afstand.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 shrink-0">
            <Link
              to="/it-support"
              className="group inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-neutral-900 px-7 py-4 text-[15px] font-semibold tracking-wide transition-colors"
              data-testid="cta-banner-its"
            >
              <ShieldCheck size={16} />
              Bekijk abonnement
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href={`tel:${siteInfo.phoneRaw}`}
              className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-white hover:bg-white/10 text-white px-7 py-4 text-[15px] font-medium tracking-wide transition-colors"
            >
              <Phone size={16} />
              {siteInfo.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
